import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const insuranceSelector = (state: RootState) => state.amwell.activeConsumer.insurance;

export const insuranceDataSelector = createSelector(insuranceSelector, i => i.data);
export const insuranceDataErrorSelector = createSelector(insuranceSelector, i => i.error);
export const insuranceDataLoadingSelector = createSelector(insuranceSelector, i => i.loading);
